import React from 'react'
import { Col, Row , Container } from 'react-bootstrap'

function CentillionMap() {
  return (
    <div>
      
    <Row className='mt-0'>
     <Col lg={12}>
                      {/* <iframe className='w-100' src="https://www.google.com/maps/embed/v1/search?q=Centillion+Softech&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}
                     
<iframe className='w-100'  src="https://www.google.com/maps/embed/v1/search?q=Centillion+Softech+Pvt+Ltd&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"  width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                      </Col>
     </Row>

    </div>
  )
}

export default CentillionMap
